import { useTranslation } from 'react-i18next';

import type { MeldConcept } from '@/lib/melden/concept';
import type { MeldErnst, MeldSoort } from '@/lib/melden/types';

const SOORTEN: readonly MeldSoort[] = ['probleem', 'idee', 'vraag'];
const ERNSTEN: readonly MeldErnst[] = ['blokkeert', 'hindert', 'klein'];
const VELD =
  'mt-1 block w-full rounded-sm border border-border bg-bg-primary px-sm py-1.5 text-[13px] text-text-primary ' +
  'focus:border-border-strong focus:outline-hidden';

/** The words of a melding: what kind, how bad, one line and the story. */
export function MeldFormulier({ concept, onChange }: { concept: MeldConcept; onChange: (c: MeldConcept) => void }) {
  const { t } = useTranslation();
  return (
    <div className="mt-4 space-y-3">
      <fieldset>
        <legend className="text-[12.5px] text-text-muted">{t('melden.veld.soort')}</legend>
        <div className="mt-1 flex flex-wrap gap-3">
          {SOORTEN.map((s) => (
            <label key={s} className="flex items-center gap-1.5 text-[13px] text-text-primary">
              <input type="radio" name="meld-soort" checked={concept.soort === s} onChange={() => onChange({ ...concept, soort: s })} />
              {t(`melden.soort.${s}`)}
            </label>
          ))}
        </div>
      </fieldset>
      <fieldset>
        <legend className="text-[12.5px] text-text-muted">{t('melden.veld.ernst')}</legend>
        <div className="mt-1 flex flex-wrap gap-3">
          {ERNSTEN.map((e) => (
            <label key={e} className="flex items-center gap-1.5 text-[13px] text-text-primary">
              <input type="radio" name="meld-ernst" checked={concept.ernst === e} onChange={() => onChange({ ...concept, ernst: e })} />
              {t(`melden.ernst.${e}`)}
            </label>
          ))}
        </div>
      </fieldset>
      <label className="block text-[12.5px] text-text-muted">
        {t('melden.veld.titel')}
        <input value={concept.titel} maxLength={120} onChange={(ev) => onChange({ ...concept, titel: ev.target.value })} className={VELD} />
      </label>
      <label className="block text-[12.5px] text-text-muted">
        {t('melden.veld.omschrijving')}
        <textarea
          rows={4}
          maxLength={4000}
          value={concept.omschrijving}
          onChange={(ev) => onChange({ ...concept, omschrijving: ev.target.value })}
          className={VELD}
        />
      </label>
    </div>
  );
}
